import { SessionStorageEnum } from "@/apps/merchant3/enums/sessionStorageEnum";
import { store } from "@/shared-store";

export const cancelCartState = async (): Promise<void> => {
  await store.dispatch("customer/resetCustomer");
  await store.dispatch("carts/resetCart");
  await store.dispatch("offers/resetOffers");

  sessionStorage.removeItem(SessionStorageEnum.CartTag);
  sessionStorage.removeItem(SessionStorageEnum.RedirectUrl);
  sessionStorage.removeItem(SessionStorageEnum.CartStatus);
  sessionStorage.removeItem(SessionStorageEnum.PersonRegistrationTag);
  sessionStorage.removeItem(SessionStorageEnum.UserTag);
  sessionStorage.removeItem(SessionStorageEnum.UniqueRequestList);
  sessionStorage.removeItem(SessionStorageEnum.DataDogRumSessionType);
};

export default cancelCartState;
